import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'app-guidance-dialog',
  templateUrl: './guidance-dialog.component.html'
})
export class GuidanceDialogComponent {
  showMore = false;
  isConfirmationMode = false;

  constructor(
    public dialogRef: MatDialogRef<GuidanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isConfirmationMode = data.confirmation === true;
  }

  saveToWorkstream() {

    this.dialogRef.close('save');
  }
}

